import _ from 'lodash';
import createWorker from './createWorker';

class TreeWorker {
  #worker = null;

  constructor() {
    this.#initWorker();
  }

  #initWorker() {
    let version = Date.now();

    if (GT.productVersion && GT.productVersion.buildVersion) {
      version = GT.productVersion.buildVersion;
    }

    this.#worker = createWorker(`/workers/tree_worker.js?${version}`);
  }

  async calculate(projectsGanttTasksMap) {
    if (!projectsGanttTasksMap) {
      return Promise.resolve({});
    }

    const calculatedData = await this.#worker(_.cloneDeep(projectsGanttTasksMap));

    return Promise.resolve(calculatedData);
  }
}

export default new TreeWorker();
